class VideoFlex extends HTMLElement {
    constructor() {
        super();
        this.videos = this.querySelectorAll('.video-flex__video');
    }

    async connectedCallback() {
        if (this.videos.length > 0) {
            const { VidstackPlayer: Player, VidstackPlayerLayout } = await import('https://cdn.vidstack.io/player@v1.11.30');
            this.initBlockVideo(Player, VidstackPlayerLayout);
        }
    }

    async initBlockVideo(VidstackPlayer, VidstackPlayerLayout) {
        this.videos.forEach(async (video) => {
            const title = video.getAttribute('data-title');
            const videoSrc = video.getAttribute('data-src');
            
            const player = await VidstackPlayer.create({
                target: video,
                title: title,
                controls: false,
                playsInline: true,
                loop: true,
                src: videoSrc,
                autoPlay: true,
                muted: true,
                layout: new VidstackPlayerLayout({
                    thumbnails: '',
                }),
            });

            const thumbInstance = player;
            thumbInstance.subscribe(({ canPlay }) => {
                if (canPlay) {
                    console.log('canPlay');
                    video.parentNode.classList.add('video-flex--can-play');
                }
            });
        });
    }
}

customElements.define('video-flex', VideoFlex);
